<template>
  <div class="container">
    <div class="header">
      <p style="color: #526069; font-size: 18px">企业充值</p>
      <div>
        <!-- <el-button
          type="primary"
          @click="chargeVisible=true"
          style="height: 35px;width: 126px;line-height: 10px;color: #fff;background-color: #2ecc72;border: 1px transparent"
        >企业钱包充值</el-button> -->
        <el-button
          type="primary"
          style="height: 35px; width: 126px; line-height: 10px; color: #fff"
          @click="exportExcel"
          >导出报表</el-button
        >
      </div>
    </div>
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      style="text-align: left"
    >
      <el-form-item class="efi fl1" label="企业名称:">
        <el-input
          class="ein"
          v-model="formInline.companyName"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item class="fl2">
        <el-date-picker
          class="date"
          v-model="dateRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="fl3">
        <el-select v-model="value" @change="searchList(value)">
          <el-option label="全部状态" value="全部状态"></el-option>
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.type"
            >{{ item.name }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item class="fl4">
        <div>
          <el-button
            type="primary"
            style="height: 35px; line-height: 10px"
            @click="getList(1)"
            >查询</el-button
          >
          <el-button
            type="info"
            style="height: 35px; line-height: 10px"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <div class="total" style="height: 50px; margin-top: 0">
      <p style="color: #666; font-size: 18px; margin-right: 10px">共计充值</p>
      <p style="color: #ff8c65; font-size: 18px">￥ {{ totalCharge }}</p>
    </div>
    <el-table :data="tableData" stripe class="table">
      <el-table-column
        align="center"
        prop="name"
        label="企业名称"
        width="180"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="amount"
        :formatter="toFixed"
        label="充值金额(元)"
        width="180"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="operator"
        label="申请人"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        :formatter="dateFormat"
        label="申请时间"
      ></el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <span>{{ statusChange(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作人员" width="180">
        <template slot-scope="scope">
          <span
            class="status"
            v-show="scope.row.status == 0"
            @click="
              auditDetail(scope.row.orderId, scope.row.name, scope.row.amount)
            "
            >审核</span
          >
          <span
            class="status"
            v-show="scope.row.status == 2 || scope.row.status == 3"
            @click="toViewDetail(scope.row.orderId, scope.row.name)"
            >查看详情</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagi"
      background
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="getList"
    ></el-pagination>
    <el-dialog
      title="企业钱包充值"
      :visible.sync="chargeVisible"
      width="35%"
      :before-close="handleClose"
    >
      <div
        style="
          height: 1px;
          width: 100%;
          background-color: #f5f5f5;
          margin-top: 10px;
          margin-bottom: 10px;
        "
      ></div>
      <div>
        <el-carousel
          ref="carousel"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          height="280px"
          :setActiveItem="carouseStartIndex"
          :initial-index="carouseStartIndex"
        >
          <el-carousel-item :key="0">
            <el-form :model="form" class="page-form">
              <el-form-item
                label="手机号:"
                :label-width="formLabelWidth"
                class="form-input"
              >
                <el-input
                  v-model="form.phone"
                  auto-complete="off"
                  placeholder="请输入手机号"
                ></el-input>
                <div v-if="show" class="text-com">* 没有找到匹配的公司 *</div>
              </el-form-item>
            </el-form>
            <div
              style="
                height: 1px;
                width: 100%;
                background-color: #f5f5f5;
                margin-top: 10px;
                margin-bottom: 10px;
              "
            ></div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: -5px;
              "
            >
              <el-button type="primary" plain @click="nextPress"
                >下一步</el-button
              >
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <el-form :model="form" class="page-form">
              <el-form-item
                label="企业名称"
                :label-width="formLabelWidth"
                class="form-input"
              >
                <el-select v-model="form.accountNo">
                  <el-option
                    v-for="item in companyList"
                    :value="item.accountNo"
                    :label="item.name"
                    :key="item.accountNo"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="充值金额:"
                :label-width="formLabelWidth"
                class="form-input"
              >
                <el-input
                  v-model="form.money"
                  auto-complete="off"
                  type="number"
                  placeholder="请输入充值金额"
                  :prefix-icon="rIcon"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="充值备注:"
                :label-width="formLabelWidth"
                class="form-input"
              >
                <el-input
                  v-model="form.desc"
                  auto-complete="off"
                  placeholder="请输入充值备注"
                  :prefix-icon="rIcon"
                ></el-input>
              </el-form-item>
            </el-form>
            <div
              style="
                height: 1px;
                width: 100%;
                background-color: #f5f5f5;
                margin-top: 10px;
                margin-bottom: 10px;
              "
            ></div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: -5px;
              "
            >
              <el-button type="primary" plain @click="prePress"
                >上一步</el-button
              >
              <el-button type="primary" plain @click="thirdStep"
                >下一步</el-button
              >
            </div>
          </el-carousel-item>
          <el-carousel-item :key="1">
            <div class="page-form">
              <div class="ensure">
                <span class="ensure-name">企业名称</span>
                <span class="ensure-value">{{ form.companyName }}</span>
              </div>
              <div class="ensure">
                <span class="ensure-name">充值金额</span>
                <span class="ensure-value">￥ {{ form.money }}</span>
              </div>
              <div class="ensure">
                <span class="ensure-name">充值备注</span>
                <span class="ensure-value">{{ form.desc }}</span>
              </div>
              <div
                style="
                  height: 1px;
                  width: 100%;
                  background-color: #f2f2f2;
                  margin-top: 10px;
                  margin-bottom: 10px;
                "
              ></div>
              <div class="ensure-tips">注：请认真核对充值企业和充值金额</div>
              <div class="ensure-button">
                <el-button type="primary" plain @click="prePress"
                  >上一步</el-button
                >
                <el-button type="primary" plain @click="recharge"
                  >确认充值</el-button
                >
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <el-dialog
      title="企业充值详情"
      :visible.sync="editVisible"
      @close="closeDialog"
      align="center"
      width="30%"
    >
      <div class="content">
        <div class="name">
          <span class="nameText">充值公司 :</span>
          <span class="nameValue">{{ companyName }}</span>
        </div>
        <div class="name">
          <span class="nameText">充值金额 :</span>
          <span class="nameValue"
            >￥{{ refundRecordData.amount | number }}</span
          >
        </div>
        <div class="text">
          <span class="nameText">充值备注 :</span>
          <span class="nameValue">{{ refundRecordData.desc }}</span>
        </div>
        <div class="name">
          <span class="nameText">申请时间 :</span>
          <span class="nameValue">{{ refundRecordData.createTime }}</span>
        </div>
        <div class="name">
          <span class="nameText">申请人 :</span>
          <span class="nameValue">{{ refundRecordData.operator }}</span>
        </div>
        <div class="name">
          <span class="nameText">状态 :</span>
          <span class="nameValue">{{
            statusChange(refundRecordData.status)
          }}</span>
        </div>
        <div v-show="refundRecordData.status != 0">
          <div class="name">
            <span class="nameText">审核人 :</span>
            <span class="nameValue">{{ refundRecordData.updateUser }}</span>
          </div>
          <div class="text" v-show="refundRecordData.status == 3">
            <span class="nameText">审核备注 :</span>
            <span class="nameValue">{{ refundRecordData.updateDesc }}</span>
          </div>
          <div class="name">
            <span class="nameText">审核时间 :</span>
            <span class="nameValue">{{ refundRecordData.updateTime }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="企业充值详情"
      :visible.sync="auditVisible"
      @close="closeDialog"
      align="center"
      width="30%"
    >
      <div class="content">
        <div class="name">
          <span class="nameText">充值公司 :</span>
          <span class="nameValue">{{ companyName }}</span>
        </div>
        <div class="name">
          <span class="nameText">充值金额 :</span>
          <span class="nameValue">￥{{ auditData.amount | number }}</span>
        </div>
        <div class="text">
          <span class="nameText">充值备注 :</span>
          <span class="nameValue">{{ auditData.desc }}</span>
        </div>
        <div class="name">
          <span class="nameText">申请时间 :</span>
          <span class="nameValue">{{ auditData.createTime }}</span>
        </div>
        <div class="name">
          <span class="nameText">申请人 :</span>
          <span class="nameValue">{{ auditData.operator }}</span>
        </div>
        <div class="name">
          <span class="nameText">状态 :</span>
          <span class="nameValue">{{ statusChange(auditData.status) }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isAudit(4, '')">驳回充值</el-button>
        <el-button type="primary" @click="isAudit(2, '')">确认充值</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="'确定驳回企业充值'"
      :visible.sync="delVisible"
      align="center"
      width="30%"
    >
      <div class="box">
        <span class="text">驳回后，申请金额不会充值到企业账户中。</span>
        <div class="ein">
          <el-input
            v-model="rejected"
            placeholder="可输入驳回理由（选填）"
            maxlength="50"
          ></el-input>
          <span class="tip">{{ this.rejected.length }}/50</span>
        </div>
      </div>
      <span slot="footer" class="del-footer">
        <el-button type="primary" @click="delVisible = false"
          >考虑一下</el-button
        >
        <el-button @click="isAudit(3, rejected)">确定驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import R from "../../assets/images/royal1.png";
import {
  getChargeDeal,
  getTotalCharge,
  preCharge,
  getCompanyByOid,
  toCharge,
  getCompanyInfoByPhone,
  RechargeDetail,
  auditRecharge,
} from "@/api/finance";
import { toFixed, compareTime } from "@/utils";
import { validateTel } from "@/utils/validate";
import { downloadExcel } from "@/utils/downloadFetch";
import { shop_url } from "@/global";
export default {
  name: "",
  props: [""],
  data() {
    return {
      tableData: [],
      totalCharge: 0,
      show: false,
      form: {
        phone: "",
        accountNo: "",
        money: "",
        dssc: "",
        companyName: "", //这个name是给充值的时候 第三部显示用的
      },
      formInline: {
        companyName: "", //这个name是给条件查询的form用的
        type: "",
      },
      dateRange: [],
      chargeVisible: false,
      formLabelWidth: "120px",
      total: 0,
      page: 1,
      pageSize: 10,
      orderId: "",
      rIcon: "￥",
      carouseStartIndex: 0,
      companyList: [],
      editVisible: false,
      auditVisible: false,
      delVisible: false,
      refundRecordData: {},
      auditData: {},
      companyName: "",
      rejected: "",
      amount: "",
      options: [
        { type: "0", name: "未审核" },
        { type: "2", name: "审核成功" },
        { type: "3", name: "审核失败" },
      ],
      value: "全部状态",
    };
  },
  mounted() {
    this.getTotal();
    this.getList(1);
  },
  methods: {
    nextPress() {
      if (validateTel(this.form.phone)) {
        this.getCompanyInfo(this.form.phone);
      } else {
        this.$message({
          message: "请填写手机号",
          type: "error",
        });
      }
    },
    thirdStep() {
      // var reg = new RegExp("^[0-9]*$");
      //  if(!reg.test(this.form.money)){
      //   this.$message({
      //     message: '请输入正确的金额',
      //     type: 'error'
      //   })
      //   return
      // }
      if (!this.form.money) {
        this.$message({
          message: "请填输入金额",
          type: "error",
        });
        return;
      }
      if (!this.form.accountNo) {
        this.$message({
          message: "请选择公司",
          type: "error",
        });
        return;
      }
      this.preCharge();
    },
    prePress() {
      this.$refs.carousel.prev();
    },
    getTotal() {
      getTotalCharge().then((res) => {
        this.totalCharge = toFixed(res.data.totalRecharge);
      });
    },
    getList(page) {
      this.page = page;
      if (this.dateRange) {
        this.formInline.date1 = this.dateRange[0];
      } else {
        this.formInline.date1 = "";
      }
      if (this.dateRange) {
        if (this.dateRange[1]) {
          let arr = this.dateRange[1].split(" ");
          this.formInline.date2 = arr[0];
        } else {
          this.formInline.date2 = "";
        }
      } else {
        this.formInline.date2 = "";
      }

      console.log(this.formInline);
      getChargeDeal(this.formInline, page, this.pageSize).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.count;
        console.log(this.tableData);
      });
    },
    searchList(val) {
      if (val == "全部状态") {
        let page = this.page;
        this.formInline.date1 = this.dateRange[0] ? this.dateRange[0] : "";
        this.formInline.date2 = this.dateRange[1] ? this.dateRange[1] : "";
        this.formInline.type = "";
        console.log(this.formInline);
        getChargeDeal(this.formInline, page, this.pageSize).then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.count;
          console.log(this.tableData);
        });
      } else {
        let page = this.page;
        this.formInline.date1 = this.dateRange[0] ? this.dateRange[0] : "";
        this.formInline.date2 = this.dateRange[1] ? this.dateRange[1] : "";
        this.formInline.type = val;
        console.log(this.formInline);
        getChargeDeal(this.formInline, page, this.pageSize).then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.count;
          console.log(this.tableData);
        });
      }
    },
    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    preCharge() {
      //        this.form.money = toFixed(this.form.money)
      preCharge(this.form).then((res) => {
        this.orderId = res.data.orderId;
        this.getCompanyInfoByOid(this.orderId);
      });
    },
    getCompanyInfo(phone) {
      getCompanyInfoByPhone(phone).then((res) => {
        let data = res.data.data;
        if (data.length != 0) {
          if (data.length == 1) {
            this.form = data[0];
            this.form["phone"] = phone;
          }

          for (let index = 0; index < data.length; index++) {
            data[index]["phone"] = phone;
          }
          this.$refs.carousel.next();
          this.companyList = data;
        } else {
          this.show = true;
        }
      });
    },
    /* 根据orderID获取充值信息 */
    getCompanyInfoByOid(oid) {
      getCompanyByOid(oid)
        .then((res) => {
          this.form.companyName = res.data.name;
          this.form.money = toFixed(res.data.amount);
          this.form.orderId = res.data.orderId;
          this.form.desc = res.data.desc;
          this.$refs.carousel.next();
        })
        .catch((error) => {});
    },
    getCompanyChargeData() {
      let { date1, date2 } = this.formInline;
      let flag = compareTime(date1, date2);
      if (flag) {
        //@todo 请求企业充值列表
      } else {
        this.$notify({
          title: "提示",
          message: "请正确选择时间",
          type: "warning",
          duration: 800,
        });
      }
    },
    exportExcel() {
      let formData = {
        start: this.dateRange[0],
        end: this.dateRange[1],
      };
      if (this.dateRange) {
        if (this.dateRange[1]) {
          let arr = this.dateRange[1].split(" ");
          formData.end = arr[0];
        } else {
        }
      } else {
      }
      if (this.formInline.companyName) {
        formData.companyName = this.formInline.companyName;
      } else if (this.formInline.type) {
        formData.type = this.formInline.type;
      }
      downloadExcel({
        method: "post",
        fileName: "企业充值数据报表.xls",
        url: `${shop_url}/shop/cms/print/recharge`,
        data: formData,
      }).then((res) => {
        console.log(res);
      });
    },
    reset() {
      this.formInline = {
        companyName: "",
        date1: "",
        date2: "",
      };
      this.dateRange = [];
      this.getList(1);
    },
    recharge() {
      toCharge(this.orderId, this.form).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: "充值成功",
            type: "success",
          });
          this.chargeVisible = false;
          this.resetInfo();
          this.reset();
          this.getTotal();
          this.getList(1);
        } else {
          this.$message({
            message: "充值失败",
            type: "error",
          });
        }
      });
    },
    handleClose() {
      this.chargeVisible = false;
      this.resetInfo();
    },
    resetInfo() {
      this.$refs.carousel.setActiveItem(0);
      this.carouseStartIndex = 0;
      this.form.phone = "";
      this.form.money = "";
      this.orderId = "";
      this.companyName = "";
      this.form.accountNo = "";
      this.companyList = [];
    },
    // 充值状态变换
    statusChange(val) {
      switch (val) {
        case 0:
          return "审核中";
          break;
        case 2:
          return "审核成功";
          break;
        case 3:
          return "审核失败";
          break;
        default:
          return "状态错误";
      }
    },
    closeDialog() {
      this.editVisible = false;
    },
    toViewDetail(id, name) {
      this.companyName = name;
      let data = {
        orderId: id,
      };
      RechargeDetail(data)
        .then((res) => {
          console.log(res);
          this.refundRecordData = res.data;
          this.editVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    auditDetail(id, name, amount) {
      this.companyName = name;
      this.amount = amount;
      let data = {
        orderId: id,
      };
      RechargeDetail(data)
        .then((res) => {
          console.log(res);
          this.auditData = res.data;
          this.auditVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isAudit(type, desc) {
      let data = {
        orderId: this.auditData.orderId,
        type: type,
        desc: desc,
      };
      if (type == 2) {
        auditRecharge(data).then((res) => {
          console.log(res);
          this.$message(
            this.companyName + "充值成功，充值金额：" + this.amount
          );
          this.amount = "";
          this.auditVisible = false;
          this.delVisible = false;
          this.getList(this.page);
        });
      } else if (type == 4) {
        this.delVisible = true;
      } else {
        auditRecharge(data).then((res) => {
          console.log(res);
          this.rejected = "";
          this.auditVisible = false;
          this.delVisible = false;
          this.getList(this.page);
        });
      }
    },
  },
  watch: {
    rejected(val) {
      console.log(val);
      if (val.length == 50) {
        this.$message("驳回通知最多输入50个字");
      }
    },
  },
  filters: {
    number: function (val) {
      val = String(val).replace(/\$|\,/g, "");
      if (isNaN(val)) {
        val = "0";
      }
      let sign = val == (val = Math.abs(val));
      val = Math.floor(val * 100 + 0.50000000001);
      let cents = val % 100;
      val = Math.floor(val / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
        val =
          val.substring(0, val.length - (4 * i + 3)) +
          "," +
          val.substring(val.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + val + "." + cents;
    },
  },
};
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0 30px 30px 30px;
  display: flex;
  flex-direction: column;
}
.demo-form-inline {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.demo-form-inline .fl1 {
  flex-basis: 26%;
}
.demo-form-inline .fl2 {
  flex-basis: 37%;
}
.demo-form-inline .fl3 {
  flex-basis: 20%;
}
.demo-form-inline .fl4 {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.table {
  margin-top: 20px;
}

.form-input {
  width: 90%;
}

.ensure-button {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.ensure {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.ensure {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.ensure-name {
  color: #666;
  font-size: 14px;
  margin-right: 20px;
}

.ensure-value {
  color: #a3a3a3;
  font-size: 14px;
}

.ensure-tips {
  text-align: left;
  width: 90%;
  color: #ff6d6d;
  margin-bottom: 20px;
}

.total {
  width: 100%;
  height: 50px;
  background-color: #2ecc72aa;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.pagi {
  align-self: center;
  margin-top: 24px;
}

.table {
  margin-top: 20px;
}

.form-input {
  width: 90%;
}

.ensure-button {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.ensure {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.ensure {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.ensure-name {
  color: #666;
  font-size: 14px;
  margin-right: 20px;
}

.ensure-value {
  color: #a3a3a3;
  font-size: 14px;
}

.ensure-tips {
  text-align: left;
  width: 90%;
  color: #ff6d6d;
  margin-bottom: 20px;
}

.total {
  width: 100%;
  height: 90px;
  margin-top: 20px;
  background-color: #2ecc7210;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.pagi {
  align-self: center;
  margin-top: 24px;
}
.page-form {
  height: 65%;
}
.text-com {
  color: #ff6d6d;
}
.status {
  cursor: pointer;
  color: #409eff;
}
.content {
  width: 100%;
  height: 100%;
  margin-top: -30px;
}
.content .name {
  display: flex;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  color: #666666;
  text-align: left;
}
.content .name .nameText {
  flex-basis: 25%;
}
.content .name .nameValue {
  flex: 1;
}
.content .text {
  display: flex;
  height: auto;
  font-size: 15px;
  line-height: 40px;
  color: #666666;
  text-align: left;
  position: relative;
}
.content .text .nameText {
  flex-basis: 25%;
  position: absolute;
  top: 0;
  padding-left: 0;
}
.content .text .nameValue {
  flex: 1;
  margin-left: 25%;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
.dialog-footer .el-button--primary {
  width: 50%;
  color: rgba(2, 167, 240, 1);
  background: #fff;
  border: 1px solid rgba(2, 167, 240, 1);
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  margin-top: -30px;
}
.box .text {
  font-size: 14px;
  line-height: 50px;
}
.del-footer {
  display: flex;
  justify-content: space-around;
}
.del-footer .el-button--primary {
  color: #d9001b;
  background: #fff;
  border: 1px solid rgba(217, 0, 27, 1);
}
.del-footer .el-button--default {
  color: rgba(2, 167, 240, 1);
  background: #fff;
  border: 1px solid rgba(2, 167, 240, 1);
}
.ein {
  position: relative;
}
.tip {
  display: inline-block;
  width: 50px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/ReCharge.vue